import { ThemeProvider, type ThemeProviderProps } from "@mui/system";

import { berlinTheme } from "./theme";

export function BerlinThemeProvider(props: Omit<ThemeProviderProps, "theme">) {
  const { children } = props;

  return <ThemeProvider theme={berlinTheme}>{children}</ThemeProvider>;
}
